import React from 'react'
import { Col, Row } from 'react-bootstrap'
import bannerImg from '../../../../assets/images/banner.png'

const Banner = () => {
    return (
        <section className="banner">
            <div className="appContainer w-100">
                <Row className='align-items-center'>
                    <Col xs={12} lg={6} className='my-3'>
                        <h1><span className="banner-heading">Your Love Story</span> <br /> <span className="banner-heading">Starts Now</span></h1>
                        <p className='mt-3 mb-4 grey-text text-capitalize p-lg'>Find your perfect match and start a new <br /> chapter in your love story</p>
                    </Col>
                    <Col xs={12} lg={6} className='my-3'>
                        <img src={bannerImg} alt="banner" className='banner-img img-fluid' />
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default Banner
